import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Button, TitleBar, useSubmitButton } from "../Atoms";
import { Link, useNavigate } from "react-router-dom-v5-compat";
import { useVenue } from "../VenueContext";
import { LogoImage } from "../MainPage";
import { createCart, deleteCart, deleteSession } from "../Cart/requests";
import { useSession, useSessionDispatch } from "../Session/SessionContext";
import { getTabTotal } from "../Session/sessionSelectors";

const ClearCart = () => {
  const { t } = useTranslation();

  const venue = useVenue();
  const session = useSession();
  const cart = session.cart;

  const dispatch = useSessionDispatch();
  const navigate = useNavigate();
  const outstandingBalance = getTabTotal(session.customerTab);
  const [submissionState, trackSubmit] = useSubmitButton();

  const closeCart = async () => {
    await deleteCart(cart.uuid);
    await deleteSession();
    dispatch({
      action: "closeCart",
    });
    dispatch({ action: "updateCustomerTab", payload: null });
    const response = await createCart({ venueId: cart.venueId });
    dispatch({
      action: "updateCart",
      payload: response,
    });
    navigate("/");
  };
  return (
    <div className="pb-64 md:py-24 space-y-24">
      <div className="md:flex">
        <Link to="/" className="hidden flex-1 md:flex items-center space-x-16">
          <div className="max-w-[64px] w-full">
            <LogoImage venue={venue} />
          </div>
          <div className="text-venue-primary text-lg font-bold">
            {venue.name}
          </div>
        </Link>
        <div className="md:flex-1">
          <TitleBar>
            <div className="md:text-4xl md:font-bold">
              {t("clearOrder.title")}
            </div>
          </TitleBar>
        </div>
        <div className="flex-1" />
      </div>

      <div className="space-y-32  mx-auto max-w-sm border-[6px] border-venue-tertiary rounded-venue-brand p-32  ">
        <div className="font-bold text-center">
          {}
          {outstandingBalance
            ? t("clearOrder.descriptionWithBalance")
            : t("clearOrder.description")}
        </div>
        <div>
          <Button
            submissionState={submissionState}
            submissionOptions={{ loadingMessage: t("clearOrder.clearing") }}
            alert
            onClick={trackSubmit(closeCart)}
          >
            {t("clearOrder.action")}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ClearCart;
